import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const DecoratedListItemHeader = ({ itemName, itemConfig }) => {
  const clacInputWidth = (itemsCount = itemConfig?.titleArray?.length) =>
    itemsCount ? 100 / (itemsCount + 1) : 100
  const classes = useStyles({ columnWidth: clacInputWidth() })

  return (
    <>
      <div className={classes.contentWrapper}>
        {/* The Text */}
        <div className={classes.contentText}>{itemName}</div>
        {/* The Elements */}
        {Array.isArray(itemConfig?.controlArray) &&
          itemConfig.titleArray.map((item, idx) => {
            return (
              <div key={idx} className={classes.contentInput}>
                {item}
              </div>
            )
          })}
      </div>
      {/* The Close Button */}
      <div className={classes.deleteButtonWrrapper}></div>
    </>
  )
}

export default React.memo(DecoratedListItemHeader)

const useStyles = makeStyles((theme, props) => ({
  contentWrapper: {
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  contentText: {
    width: props => `${props.columnWidth}%`,
    padding: '0 3px',
    // ...theme.typography.h9
    fontSize: '15px',
    fontWeight: 500,
    color: '#2C2C2C',
    wordWrap: 'break-word'
  },
  contentInput: {
    width: props => `${props.columnWidth}%`,
    padding: '0 3px'
  },
  deleteButtonWrrapper: {
    width: '10%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  deleteButton: {
    padding: '12px 0'
  }
}))
